import { useParams } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import { ErrorState, Loading } from "@/components/States";
import Presentation from "@/components/board/Presentation";

export default function PublicPresentation() {
  const { token } = useParams();
  const { data, error, loading } = useFetch(`/public/boards/${token}`);
  if (loading) return <div className="p-10"><Loading rows={3} /></div>;
  if (error) return <div className="mx-auto max-w-lg p-10"><ErrorState message={error} /></div>;
  return <Presentation title={data.project.name} subtitle={data.project.address || "Presentation"} brandName={data.workspace?.name || "E.L.M"} rooms={data.rooms} elements={data.elements} connections={data.connections} sketches={data.sketches || []} />;
}
